import { connect } from "react-redux";
import ContractDetail from "./ContractDetail";
import { compose } from "redux";
import { WithAppendHeaderAndFooterHOC } from "../../HOC/WithAppendHeaderAndFooterHOC";
import { WithAppendSidebarHOC } from "../../HOC/WithAppendSidebarHOC";
import { getCitiesList, getCitiesListReversed, getContractObjectSelector } from "./selectors";
import {
    downloadContract,
    getCatalogList,
    getCities,
    getContractFieldsItem,
    getContractInfo,
    getEntityInfoByInn,
    setNextStage
} from "./actions";
import { searchObjects } from "../Objects/actions";
import { getBaseUrlSelector, getUserRoleSelector } from "../../globalState/app/selectros";
import { WithSavingSnackBar } from "../../HOC/WithSavingSnackBar";
import { getObjectsSelector } from "../Objects/selectors";


let mapStateToProps = (state, props) => {

  return {
    object: getContractObjectSelector(state, props),
    entityType: state.contractsDetailPage.entityType,
    paymentType: state.contractsDetailPage.paymentType,
    fieldsCollections: state.contractsDetailPage.fieldsCollections,
    presetsCollectios: state.contractsDetailPage.presetsCollectios,
    presetSelect: state.contractsDetailPage.presetSelect,
    fields: state.contractsDetailPage.fields,
    requisiteId: state.contractsDetailPage.requisiteId,
    contract: state.contractsDetailPage.contract,
    prices: state.contractsDetailPage.prices,
    baseUrl: getBaseUrlSelector(state),
    blobLink: state.contractsDetailPage.blobLink,
    userRole: getUserRoleSelector(state),
    objectsList: getObjectsSelector(state),
    catalog: state.contractsDetailPage.catalog,
    city: state.contractsDetailPage.city,
    citiesList: getCitiesList(state),
    citiesListReversed: getCitiesListReversed(state),
    catalogList: state.contractsDetailPage.catalogList,
    companyFindByINN: state.contractsDetailPage.companyFindByINN,
    channelManager: state.contractsDetailPage.channelManager,
  }
};


export default compose(connect(mapStateToProps, {
  getContractInfo,
  getContractFieldsItem,
  searchObjects,
  setNextStage,
  downloadContract,
  getCities,
  getCatalogList,
  getEntityInfoByInn
}), WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithSavingSnackBar)(ContractDetail);



